<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="goToAdd"
    >新增活动
    </el-button>
    <el-table
      class="table"
      ref="table"
      :data="activityList"
      style="width: 100%">
      <el-table-column
        prop="psId"
        label="优惠ID"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="开始时间"
        align="center">
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center">
      </el-table-column>
      <el-table-column
        prop="courseCount"
        label="件数"
        align="center">
      </el-table-column>
      <el-table-column
        prop="unitPrice"
        label="单价(元)"
        align="center">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center">
        <template scope="scope">
          <el-button
            size="mini"
            @click="_deleteActivity(scope.$index, scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="alertAddActivityCourse"
    >添加优惠课程
    </el-button>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="_deleteActivityCourses"
    >删除优惠课程
    </el-button>
    <el-table
      ref="multipleTable"
      :data="activityCourseList"
      style="width: 100%"
      @selection-change="activityCourseSelection">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="courseId"
        label="课程ID"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pic"
        label="课程图片"
        align="center"
        width="150">
        <template scope="scope">
          <img :src="scope.row.pic" width="60" height="60"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="课程名称"
        align="left">
      </el-table-column>
    </el-table>
    <el-dialog title="添加优惠课程" :visible.sync="dialogTableVisible" center>
      <el-table
        ref="multipleTable"
        :data="inActivityCourseList"
        style="width: 100%"
        max-height="400"
        @selection-change="inActivityCourseSelection">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="courseId"
          label="课程ID"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pic"
          label="课程图片"
          align="center"
          width="150">
          <template scope="scope">
            <img :src="scope.row.pic" width="60" height="60"/>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="课程名称"
          align="left">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogTableVisible = false"
          size="mini"
        >取 消
        </el-button>
        <el-button
          type="primary"
          @click="_addActivityCourses"
          :disabled="inActivityCourseSelects.length === 0"
          size="mini">确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '../common/js/config';
  import {
    getActivityList,
    deleteActivity,
    getActivityCourseList,
    getInActivityCourseList,
    addActivityCourses,
    deleteActivityCourses
  } from '@/api/activity';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'activity_list',
    data() {
      return {
        activityCoursesSelects: [],
        inActivityCourseSelects: [],
        inActivityCourseList: [],
        dialogTableVisible: false
      };
    },
    created() {
      this._getActivityList();
      this._getActivityCourseList();
    },
    methods: {
      goToAdd() {
        this.$router.push('/add_activity');
      },
      _getActivityList() {
        getActivityList(this.user.userId).then((res) => {
          this.setList({
            list: res.priceScales,
            type: listType.ACTIVITY
          });
        });
      },
      _getActivityCourseList() {
        getActivityCourseList(this.user.userId).then((res) => {
          this.setList({
            list: res.priceScaleCourses,
            type: listType.ACTIVITY_COURSE
          });
        });
      },
      _getInActivityCourseList() {
        getInActivityCourseList(this.user.userId).then((res) => {
          this.inActivityCourseList = res.nonPriceScaleCourses;
          this.dialogTableVisible = true;
        });
      },
      _deleteActivity(index, item) {//删除优惠
        this.$confirm('确认删除该优惠吗？')
          .then(_ => {
            deleteActivity(this.user.userId, item.uuid).then((res) => {
              if (res.rspCode === 0) {
                this.deleteItem({
                  item,
                  type: listType.ACTIVITY
                });
                this.$message.success('删除成功');
              }
            });
          })
          .catch(_ => {
          });
      },
      _addActivityCourses() {
        this.dialogTableVisible = false;
        let courseUUIDs = [];
        for (let i = 0; i < this.inActivityCourseSelects.length; i++) {
          courseUUIDs.push(this.inActivityCourseSelects[i].courseUuid);
        }
        addActivityCourses(this.user.userId, courseUUIDs).then((res) => {
          if (res.rspCode === 0) {
            this.insertList({
              list: this.inActivityCourseSelects,
              type: listType.ACTIVITY_COURSE
            });
            this.$message.success('添加成功');
          }
        }).catch((e) => {
          this.$message.error('添加失败');
        });
      },
      _deleteActivityCourses() {
        if (!this.activityCoursesSelects.length) {
          this.$message.warning('请先选中要删除的课程');
          return;
        }
        let courseUUIDs = [];
        for (let i = 0; i < this.activityCoursesSelects.length; i++) {
          courseUUIDs.push(this.activityCoursesSelects[i].courseUuid);
        }
        this.$confirm('确认删除优惠课程吗？')
          .then(_ => {
            deleteActivityCourses(this.user.userId, courseUUIDs).then((res) => {
              if (res.rspCode === 0) {
                this.deleteItems({
                  items: this.activityCoursesSelects,
                  type: listType.ACTIVITY_COURSE
                });
                this.$message.success('删除成功');
              }
            });
          })
          .catch(_ => {
          });
      },
      activityCourseSelection(val) {
        this.activityCoursesSelects = val;
      },
      inActivityCourseSelection(val) {
        this.inActivityCourseSelects = val;
      },
      alertAddActivityCourse() {
        this._getInActivityCourseList();
      },
      ...mapActions([
        'setList',
        'insertList',
        'deleteItem',
        'deleteItems'
      ])
    },
    computed: {
      ...mapGetters([
        'activityList',
        'activityCourseList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .add-btn
      margin-bottom: 10px;
    .table
      margin-bottom: 20px;
    .pagination
      margin-top: 10px;
</style>